import { create } from "zustand";
import { GlobalState } from "./types";

export const useGlobalStore = create<GlobalState>((set) => ({
  plusButtonCallback: null,
  setPlusButtonCallback: (callback) => {
    set({
      plusButtonCallback: callback
    })
  },
}))